export default __webpack_public_path__ + "static/media/padlock.920a9974.svg";